import { Stack, Typography } from '@packages/shared';

interface ContentProps {
  smallText: string;
  bigText: string;
}

export const Content = ({ smallText, bigText }: ContentProps) => (
  <Stack direction="column" alignItems="center" width="50%">
    <Typography variant="body3">{smallText}</Typography>
    <Typography variant="h3" component="p" mt={0.5}>
      {bigText}
    </Typography>
  </Stack>
);
